import { useAuth } from './AuthContext';

/**
 * Whether this account marks a review or only reads it. The tours' pages
 * open to a tester (the owner, 2026-09-29), who reads what was marked and
 * decided and changes none of it: the platform refuses the write as well,
 * and a page that offered the buttons would only show its refusal.
 */
export function useCanReview(): boolean {
  return useAuth().me.roles.includes('ADMIN');
}
